import request from 'utils/request'

const { REACT_APP_API_URL: API_URL } = process.env

export const loading = (type = '') => ({ type: `${type}_LOADING` })
export const fail = (type = '', error) => ({ type: `${type}_FAIL`, error })
export const success = (type = '', payload) => ({ type: `${type}_SUCCESS`, payload })

const methods = ['delete', 'get', 'patch', 'post', 'put']

const creator = method => (endpoint, actionType, ...args) => dispatch =>
  request[method](`${API_URL}${endpoint}`, ...args)
    .then(response => dispatch(success(actionType, response)))
    .catch(error => dispatch(fail(actionType, error)))

const statusCreator = method => (endpoint, actionType, ...args) => dispatch => {
  dispatch(loading(actionType))
  request[method](`${API_URL}${endpoint}`, ...args)
    .then(response => dispatch(success(actionType, response)))
    .catch(error => dispatch(fail(actionType, error)))
}

export default methods.reduce((a, b) => ({ ...a, [b]: creator(b) }), {})

export const statusAction = methods.reduce((a, b) => ({ ...a, [b]: statusCreator(b) }), {})